// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.luckysheet-sheets-add {
    display: none !important;
  }
#luckysheet-sheets-m{
    display: none !important;  
}
#luckysheet-sheet-container-c{
    display: none !important;  
}
#luckysheet-sheets-leftscroll,#luckysheet-sheets-rightscroll{
    display: none !important;  
}
#luckysheet-bottom-add-row, #luckysheet-bottom-bottom-top{
    height: 16px !important;
    padding: 0px 10px 6px 9px !important;
    line-height: 23px !important;
}
#luckysheet-bottom-bottom-top{
    margin-left: 10px;
}

#luckysheet-bottom-add-row-input {
    font-size: 1rem;
    box-sizing: content-box;
    height: 30px;
    margin: 0 0 8px 0;
    margin-left: 10px;
    margin-right: 10px;
    padding: 0;
    transition: box-shadow .3s, border .3s;
    border: none;
    border-bottom: 1px solid #9e9e9e;
    border-radius: 5px;
    outline: none;
    background-color: #fff;
    box-shadow: none;
    text-align: center;
}
.flatpickr-current-month {
    font-size: 135%;
    line-height: inherit;
    font-weight: 300;
    color: inherit;
    position: absolute;
    width: 75%;
    left: 12.5%;
    padding: 0 0 0 0 !important;
    line-height: 1;
    height: 34px;
    display: inline-block;
    text-align: center;
    transform: translate3d(0,0,0);
}
.flatpickr-months .flatpickr-month {
    height: 45px !important;
}
#luckysheet-dataVerification-showHintBox {
    display: none !important;
}
.luckysheet_scrolltable .luckysheet-cols-menu-container > div > div:nth-child(1) .luckysheet-cell-text {
    font-size: 16px; /* Adjust the font size as needed */
  }
  .flatpickr-current-month .numInputWrapper {
    width: 110px !important;
    display: inline-block;
}

/* Hide the default file input */
.file-input {
    display: none;
}

/* Style the custom file button */
.custom-file-button {
    display: inline-block;
    padding: 8px 16px;
    background-color: #3498db;
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 4px;
}

#luckysheet-dataVerification-dropdown-List {
    background-color: #fff !important;
    border: 1px solid #ccc !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2) !important;
    position: absolute !important;
    z-index: 20000 !important;
    box-sizing: border-box !important;
    width: auto !important;
    font-weight: 500;
}

#scrolldrop{
    /* height: 100px;  */
}

/* #luckysheet-dataVerification-dropdown-List.active {
    z-index: 9900001 !important;
    background-color: #fff !important;
} */

/* Apply styles only to elements with the class formulaInputFocus */
input.formulaInputFocus:not([type]), input.formulaInputFocus[type=text]:not(.browser-default), input.formulaInputFocus[type=password]:not(.browser-default), input.formulaInputFocus[type=email]:not(.browser-default), input.formulaInputFocus[type=url]:not(.browser-default), input.formulaInputFocus[type=time]:not(.browser-default), input.formulaInputFocus[type=date]:not(.browser-default), input.formulaInputFocus[type=datetime]:not(.browser-default), input.formulaInputFocus[type=datetime-local]:not(.browser-default), input.formulaInputFocus[type=tel]:not(.browser-default), input.formulaInputFocus[type=number]:not(.browser-default), input.formulaInputFocus[type=search]:not(.browser-default), textarea.formulaInputFocus.materialize-textarea {
    font-size: 11px !important;
    font-weight: bold !important;
    box-sizing: content-box !important;
    /* width: auto !important; */
    min-width: 132px !important;
    max-width: 146px !important;
    height: 13px !important;
    margin: 0 0 8px 0 !important;
    margin-left: 0px !important;
    padding: 0 !important;
    transition: box-shadow .3s, border .3s !important;
    border: 1px solid #000 !important;
    /* border-bottom: 1px solid #9e9e9e !important; */
    border-radius: 2px !important;
    outline: none !important;
    background-color: transparent !important;
    box-shadow: none !important;
    padding: 5px !important;
}

.inputsearch {
    height: 16px !important;
    padding: 5px !important;
    color: #444 !important;
    border-color: #a1a1a1 !important;
}

.inputsearchitme{
    width: 160px !important;
}
.inputsearchcontainer{
    width: 110px !important;
}
.inputsearchaju{
    width: 90px !important;
}

.btn-danger{
    background-color: rgb(95, 170, 246) !important;
}

.btn-reset{
  background-color: rgb(217, 77, 52) !important;
}

button, input, optgroup, select, textarea {
    font-family: sans-serif !important;
    font-size: 100% !important;
    line-height: auto !important;
    margin-right: 5px !important;
    /* Add other properties if needed */
}

/* Apply styles only to buttons with specific IDs */
#replaceAllBtn, #replaceBtn, #searchAllBtn, #searchNextBtn, .luckysheet-model-close-btn{
    height: 24px !important;
    padding: 1px 10px 1px 10px !important;
    vertical-align: middle !important;
    text-transform: uppercase !important;
    border: none !important;
    border-radius: 2px !important;
    -webkit-tap-highlight-color: transparent !important;
}


/* Style for the sticky filter column */
.sticky-filter {
    position: sticky !important;
    top: 0 !important;
    z-index: 9999999 !important;
    background-color: #3498db !important;
  }
  
  /* Style for the frozen filter column */
  .frozen-filter {
    position: absolute;
  }
  

  #luckysheet-filter-menu{
    width: 20em !important;
  }

  .btn, .btn-large, .btn-small, .btn-flat {
    line-height: 23px !important;
    display: inline-block !important;
    height: 25px !important;
    width: auto  !important;
    vertical-align: middle !important;
    text-transform: unset !important;
    border: none !important;
    border-radius: 2px !important;
    -webkit-tap-highlight-color: transparent !important;
    font-size: 12px !important;
}

#replaceAllBtn, #replaceBtn, #replaceTab{
    display: none !important;
}
#divfkisum {
    -webkit-user-select: text;
            user-select: text;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
}

#left-div-bottom-view {
    flex: 1 1 20%;
    text-align: left;
  }
  
.selectFilter{
    width: auto !important;
    background-color: red;
    color: #fff;
    font-weight: bold;
    height: 16px;
    border-radius: 10px;
} 
#center-div-bottom-view {
flex: 2 1;
text-align: center;
}

#right-div-bottom-view {
flex: 1 1;
text-align: right;
}

.mr-b-6{
    margin-bottom: 8px;
}

#fkisum {
    font-size: 14px !important;
    background: #33ff00;
    border-radius: 5px;
    padding: 3px 5px 3px 5px;
    font-weight: bold;
    margin: 5px;
    margin-right: 10px; 
}
#fkicount {
    font-size: 14px !important;
    background: #ebeb34;
    border-radius: 8px;
    padding: 3px 5px 3px 5px;
    font-weight: bold;
    margin-right: 10px; 
}
#Selisihsum {
    font-size: 14px !important;
    background: #a5e1a6;
    border-radius: 8px;
    padding: 3px 5px 3px 5px;
    font-weight: bold;
    margin-right: 10px; 
}

.inputTextFilter {
    width: 65% !important;
    padding: 8px !important;
    margin-top: 5px !important;
    border: 1px solid #ccc !important;
    border-radius: 4px !important;
    box-sizing: border-box !important;
}

/*TABLE FILTER*/
@media screen and (max-width: 900px) {
    .responsive-table {
      width: 100%;
    }
  
    .responsive-table td,
    .responsive-table th {
      display: block;
      width: 100%;
      box-sizing: border-box;
    }
  
    .responsive-table thead {
      display: none;
    }
  }

  .form-group {
    margin-bottom: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  
  .form-label {
    margin-right: 10px;
    font-weight: 500;
  }
  
  .form-control {
    width: 100%;
    padding: 8px;
    box-sizing: border-box;
  }
  
  .container_report_view {
    display: flex;
    flex-wrap: wrap;
  }
  
  .left-side {
    flex: 1 1;
    padding: 20px;
    background: #f9fbfd;
    background: linear-gradient(181deg,#f9fbfd 0%, #ededed 80%);
    background: -moz-linear-gradient(181deg,#f9fbfd 0%, #ededed 80%);
  }
  
  .right-side {
    flex: 7 1;
    padding: 20px;
    /* border-left: 1px solid #c8c8c8; */
    height: 10000px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  .style-select-report{
    width: 120px;
  }

  .style-select-report{
    float: left;
  }

  .form-group .form-label{
    min-width: 70px;
    text-align: left;
  }

  .form-group .inputsearch {
    margin-left: 0px !important;
  }

  .inputsearchdate{
    width: 100px !important; 
  }

  .inputall{
    width: 150px !important; 
  }

  #tgl{
    float: right;
  }

  #batas{
    height: 20px;
  }

  .group-botton{
    float: right;
  }

  .luckyCssReport {
    margin: 75px 5px 0px 0px;
    padding: 0px;
    position: absolute;
    width: 80%;
    height: 90%;
    right:0;
    top: 0px;
    overflow-x: auto;
  }

  .luckyCssWithMenuResponsivesearch {
    margin: 150px 0px 0px 0px;
    padding: 0px;
    position: absolute;
    width: 100%;
    height: 83.5%;
    left: 0px;
    top: 0px;
    overflow-x: auto;
  }

  .luckyCssWithMenuResponsive {
    margin: 110px 0px 0px 0px;
    padding: 0px;
    position: absolute;
    width: 100%;
    height: 85.5%;
    left: 0px;
    top: 0px;
    overflow-x: auto;
  }

  .luckyCssWithMenu {
    margin: 70px 0px 0px 0px;
    padding: 0px;
    position: absolute;
    width: 100%;
    height: 85.5%;
    left: 0px;
    top: 0px;
    overflow-x: auto;
  }

  .luckyCssWithMenuResponsiveMobile {
    margin: 110px 0px 0px 0px;
    padding: 0px;
    position: absolute;
    width: 100%;
    height: 85.5%;
    left: 0px;
    top: 0px;
    overflow-x: auto;
  }

  .inputSearch{
    height: 20px !important;
    width: 50% !important;
    padding: 2px !important;
  }
  
  
  @media (min-width: 2560px) {
    .luckyCssReport {
      margin: 75px 5px 0px 0px;
      padding: 0px;
      position: absolute;
      width: 2200px;
      height: 90%;
      right:0;
      top: 0px;
      overflow-x: auto;
    }
    
    .style-select-report{
      width: 100%;
    }

    .style-select-report{
      width: 150px;
    }
  }

  @media (min-width: 1440px) and (max-width: 2560px){
    .luckyCssReport {
      margin: 75px 5px 0px 0px;
      padding: 0px;
      position: absolute;
      width: 84.7%;
      height: 91.5%;
      right:0;
      top: 0px;
      overflow-x: auto;
    }
    
    .style-select-report{
      width: 100%;
    }

    .style-select-report{
      width: 150px;
    }
  }

  @media(min-width: 1024px)and (max-width: 1500px) {
    .container {
      flex-direction: column;
    }
    .left-side {
        flex: 1 1;
        padding: 12px;
      }
      
      .right-side {
        flex: 7 1;
        padding: 12px;
      }

      .luckyCssReport {
        margin: 75px 5px 0px 0px;
        padding: 0px;
        position: absolute;
        width: 82.5%;
        height: 90.5%;
        right:0;
        top: 0px;
        overflow-x: auto;
      }

      .style-select-report{
        width: 130px;
      }

      .inputsearchdate{
        width: 110px !important; 
      }
    
      .inputall{
        width: 130px !important; 
      }
    
  }


  /* @media (min-width: 770px) and (max-width: 1024px) {
    .container {
      flex-direction: column;
    }
    .left-side {
        flex: 1;
        padding: 10px;
      }
      
      .right-side {
        flex: 6;
        padding: 10px;
      }

      .luckyCssReport {
        margin: 75px 5px 0px 0px;
        padding: 0px;
        position: absolute;
        width: 780px;
        height: 80%;
        right:0;
        top: 0px;
        overflow-x: auto;
      }

      .style-select-report{
        width: 90px;
      }
      .inputall{
        width: 120px !important; 
      }
  } */

  /* @media (max-width: 769px) {
    .container {
      flex-direction: column;
    }

    .left-side {
        flex: 1;
        padding: 20px;
      }
      
      .right-side {
        flex: 4;
        padding: 20px;
      }

      .luckyCssReport {
        margin: 73px 0px 0px 0px;
        padding: 0px;
        position: absolute;
        width: 479px;
        height: 80%;
        right:0;
        top: 0px;
        overflow-x: auto;
      }

      .style-select-report{
        width: 100px;
      }

      .luckyCssWithMenuResponsive {
        margin: 160px 0px 0px 0px;
        padding: 0px;
        position: absolute;
        width: 100%;
        height: 80%;
        left: 0px;
        top: 0px;
        overflow-x: auto;
      }

      .luckyCssWithMenuResponsiveMobile {
        margin: 160px 0px 0px 0px;
        padding: 0px;
        position: absolute;
        width: 100%;
        height: 80%;
        left: 0px;
        top: 0px;
        overflow-x: auto;
      }

      .btn, .btn-large, .btn-small, .btn-flat {
        line-height: 23px !important;
        display: inline-block !important;
        height: 25px !important;
        width: auto  !important;
        vertical-align: middle !important;
        text-transform: unset !important;
        border: none !important;
        border-radius: 2px !important;
        -webkit-tap-highlight-color: transparent !important;
        font-size: 12px !important;
      }
  }

  @media (min-width: 320px) and (max-width: 430px) {
    .container {
      flex-direction: column;
    }

    .left-side {
        flex: 1;
        padding: 20px;
      }
      
      .right-side {
        flex: 4;
        padding: 20px;
      }

      .luckyCssReport {
        margin: 73px 0px 0px 0px;
        padding: 0px;
        position: absolute;
        width: 479px;
        height: 80%;
        right:0;
        top: 0px;
        overflow-x: auto;
      }

      .style-select-report{
        width: 100px;
      }

      .luckyCssWithMenuResponsive {
        margin: 180px 0px 0px 0px;
        padding: 0px;
        position: absolute;
        width: 100%;
        height: 80%;
        left: 0px;
        top: 0px;
        overflow-x: auto;
      }

      .luckyCssWithMenuResponsiveMobile {
        margin: 180px 0px 0px 0px;
        padding: 0px;
        position: absolute;
        width: 100%;
        height: 75%;
        left: 0px;
        top: 0px;
        overflow-x: auto;
      }

      .btn, .btn-large, .btn-small, .btn-flat {
        line-height: 23px !important;
        display: inline-block !important;
        height: 25px !important;
        width: auto  !important;
        vertical-align: middle !important;
        text-transform: unset !important;
        border: none !important;
        border-radius: 2px !important;
        -webkit-tap-highlight-color: transparent !important;
        font-size: 12px !important;
        margin-top: 5px;
      }
  }

  @media (max-width: 320px) {
    .container {
      flex-direction: column;
    }

    .left-side {
        flex: 1;
        padding: 20px;
      }
      
      .right-side {
        flex: 4;
        padding: 20px;
      }

      .luckyCssReport {
        margin: 73px 0px 0px 0px;
        padding: 0px;
        position: absolute;
        width: 479px;
        height: 80%;
        right:0;
        top: 0px;
        overflow-x: auto;
      }

      .style-select-report{
        width: 100px;
      }

      .luckyCssWithMenuResponsive {
        margin: 220px 0px 0px 0px;
        padding: 0px;
        position: absolute;
        width: 100%;
        height: 75%;
        left: 0px;
        top: 0px;
        overflow-x: auto;
      }


      .btn, .btn-large, .btn-small, .btn-flat {
        line-height: 23px !important;
        display: inline-block !important;
        height: 25px !important;
        width: auto  !important;
        vertical-align: middle !important;
        text-transform: unset !important;
        border: none !important;
        border-radius: 2px !important;
        -webkit-tap-highlight-color: transparent !important;
        font-size: 12px !important;
        margin-top: 5px;
      }
  } */


.table-bordered {
  border-collapse: collapse;
  border: 1px solid black;
}
.table-bordered th, .table-bordered td {
  border: 1px solid black;
}


ul.tabs{
	margin: 0px;
	padding: 0px;
	list-style: none;
}
ul.tabs li{
	background: none;
	color: #222;
	display: inline-block;
	padding: 10px 15px;
	cursor: pointer;
}

ul.tabs li.current{
	background: #ededed;
	color: #222;
}

.tab-content{
	display: none;
	background: #ededed;
	padding: 15px;
}

.tab-content.current{
	display: block;
  width: 100%;
}

.showDiv{
  display: block;
}
.hideDiv {
  display: none;
}
.redFont{
  color: red;
}

.table tbody tr:nth-child(even) {
  background-color: #e7e7e7; /* Light gray background for even rows */
}

.table tbody tr:nth-child(odd) {
  background-color: #fafafa; /* White background for odd rows */
}

tr.total_row td {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/css/new.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;EAC1B;AACF;IACI,wBAAwB;AAC5B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,uBAAuB;IACvB,oCAAoC;IACpC,4BAA4B;AAChC;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,sCAAsC;IACtC,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,2BAA2B;IAC3B,cAAc;IACd,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAElB,6BAA6B;AACjC;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,eAAe,EAAE,mCAAmC;EACtD;EACA;IACE,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA,gCAAgC;AAChC;IACI,aAAa;AACjB;;AAEA,iCAAiC;AACjC;IACI,qBAAqB;IACrB,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,iCAAiC;IACjC,mDAAmD;IACnD,6BAA6B;IAC7B,yBAAyB;IACzB,iCAAiC;IACjC,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;;GAGG;;AAEH,mEAAmE;AACnE;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,kCAAkC;IAClC,4BAA4B;IAC5B,2BAA2B;IAC3B,2BAA2B;IAC3B,uBAAuB;IACvB,4BAA4B;IAC5B,2BAA2B;IAC3B,qBAAqB;IACrB,iDAAiD;IACjD,iCAAiC;IACjC,iDAAiD;IACjD,6BAA6B;IAC7B,wBAAwB;IACxB,wCAAwC;IACxC,2BAA2B;IAC3B,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;AAC3B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,8CAA8C;AAClD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;IACI,kCAAkC;IAClC,0BAA0B;IAC1B,4BAA4B;IAC5B,4BAA4B;IAC5B,mCAAmC;AACvC;;AAEA,mDAAmD;AACnD;IACI,uBAAuB;IACvB,qCAAqC;IACrC,iCAAiC;IACjC,oCAAoC;IACpC,uBAAuB;IACvB,6BAA6B;IAC7B,mDAAmD;AACvD;;;AAGA,uCAAuC;AACvC;IACI,2BAA2B;IAC3B,iBAAiB;IACjB,2BAA2B;IAC3B,oCAAoC;EACtC;;EAEA,uCAAuC;EACvC;IACE,kBAAkB;EACpB;;;EAGA;IACE,sBAAsB;EACxB;;EAEA;IACE,4BAA4B;IAC5B,gCAAgC;IAChC,uBAAuB;IACvB,uBAAuB;IACvB,iCAAiC;IACjC,gCAAgC;IAChC,uBAAuB;IACvB,6BAA6B;IAC7B,mDAAmD;IACnD,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;AAC5B;AACA;IACI,yBAAiB;YAAjB,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;EAClB;;AAEF;IACI,sBAAsB;IACtB,qBAAqB;IACrB,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;AACvB;AACA;AACA,SAAO;AACP,kBAAkB;AAClB;;AAEA;AACA,SAAO;AACP,iBAAiB;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB;IAClB,wBAAwB;IACxB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB;IAClB,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB;IAClB,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,0BAA0B;IAC1B,iCAAiC;IACjC,6BAA6B;IAC7B,iCAAiC;AACrC;;AAEA,eAAe;AACf;IACI;MACE,WAAW;IACb;;IAEA;;MAEE,cAAc;MACd,WAAW;MACX,sBAAsB;IACxB;;IAEA;MACE,aAAa;IACf;EACF;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,2DAA2D;IAE3D,gEAAgE;EAClE;;EAEA;IACE,SAAO;IACP,aAAa;IACb,oCAAoC;IACpC,eAAe;IACf,wCAAwC;EAC1C;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,wBAAwB;IACxB,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,OAAO;IACP,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,SAAS;IACT,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,SAAS;IACT,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;IACxB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,SAAS;IACT,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,SAAS;IACT,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,qBAAqB;IACrB,uBAAuB;EACzB;;;EAGA;IACE;MACE,wBAAwB;MACxB,YAAY;MACZ,kBAAkB;MAClB,aAAa;MACb,WAAW;MACX,OAAO;MACP,QAAQ;MACR,gBAAgB;IAClB;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,YAAY;IACd;EACF;;EAEA;IACE;MACE,wBAAwB;MACxB,YAAY;MACZ,kBAAkB;MAClB,YAAY;MACZ,aAAa;MACb,OAAO;MACP,QAAQ;MACR,gBAAgB;IAClB;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,YAAY;IACd;EACF;;EAEA;IACE;MACE,sBAAsB;IACxB;IACA;QACI,SAAO;QACP,aAAa;MACf;;MAEA;QACE,SAAO;QACP,aAAa;MACf;;MAEA;QACE,wBAAwB;QACxB,YAAY;QACZ,kBAAkB;QAClB,YAAY;QACZ,aAAa;QACb,OAAO;QACP,QAAQ;QACR,gBAAgB;MAClB;;MAEA;QACE,YAAY;MACd;;MAEA;QACE,uBAAuB;MACzB;;MAEA;QACE,uBAAuB;MACzB;;EAEJ;;;EAGA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KA+BG;;EAEH;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KA4LG;;;AAGL;EACE,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;;;AAGA;CACC,WAAW;CACX,YAAY;CACZ,gBAAgB;AACjB;AACA;CACC,gBAAgB;CAChB,WAAW;CACX,qBAAqB;CACrB,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,aAAa;AACd;;AAEA;CACC,cAAc;EACb,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB,EAAE,wCAAwC;AACrE;;AAEA;EACE,yBAAyB,EAAE,kCAAkC;AAC/D;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".luckysheet-sheets-add {\n    display: none !important;\n  }\n#luckysheet-sheets-m{\n    display: none !important;  \n}\n#luckysheet-sheet-container-c{\n    display: none !important;  \n}\n#luckysheet-sheets-leftscroll,#luckysheet-sheets-rightscroll{\n    display: none !important;  \n}\n#luckysheet-bottom-add-row, #luckysheet-bottom-bottom-top{\n    height: 16px !important;\n    padding: 0px 10px 6px 9px !important;\n    line-height: 23px !important;\n}\n#luckysheet-bottom-bottom-top{\n    margin-left: 10px;\n}\n\n#luckysheet-bottom-add-row-input {\n    font-size: 1rem;\n    box-sizing: content-box;\n    height: 30px;\n    margin: 0 0 8px 0;\n    margin-left: 10px;\n    margin-right: 10px;\n    padding: 0;\n    transition: box-shadow .3s, border .3s;\n    border: none;\n    border-bottom: 1px solid #9e9e9e;\n    border-radius: 5px;\n    outline: none;\n    background-color: #fff;\n    box-shadow: none;\n    text-align: center;\n}\n.flatpickr-current-month {\n    font-size: 135%;\n    line-height: inherit;\n    font-weight: 300;\n    color: inherit;\n    position: absolute;\n    width: 75%;\n    left: 12.5%;\n    padding: 0 0 0 0 !important;\n    line-height: 1;\n    height: 34px;\n    display: inline-block;\n    text-align: center;\n    -webkit-transform: translate3d(0,0,0);\n    transform: translate3d(0,0,0);\n}\n.flatpickr-months .flatpickr-month {\n    height: 45px !important;\n}\n#luckysheet-dataVerification-showHintBox {\n    display: none !important;\n}\n.luckysheet_scrolltable .luckysheet-cols-menu-container > div > div:nth-child(1) .luckysheet-cell-text {\n    font-size: 16px; /* Adjust the font size as needed */\n  }\n  .flatpickr-current-month .numInputWrapper {\n    width: 110px !important;\n    display: inline-block;\n}\n\n/* Hide the default file input */\n.file-input {\n    display: none;\n}\n\n/* Style the custom file button */\n.custom-file-button {\n    display: inline-block;\n    padding: 8px 16px;\n    background-color: #3498db;\n    color: white;\n    border: none;\n    cursor: pointer;\n    border-radius: 4px;\n}\n\n#luckysheet-dataVerification-dropdown-List {\n    background-color: #fff !important;\n    border: 1px solid #ccc !important;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2) !important;\n    position: absolute !important;\n    z-index: 20000 !important;\n    box-sizing: border-box !important;\n    width: auto !important;\n    font-weight: 500;\n}\n\n#scrolldrop{\n    /* height: 100px;  */\n}\n\n/* #luckysheet-dataVerification-dropdown-List.active {\n    z-index: 9900001 !important;\n    background-color: #fff !important;\n} */\n\n/* Apply styles only to elements with the class formulaInputFocus */\ninput.formulaInputFocus:not([type]), input.formulaInputFocus[type=text]:not(.browser-default), input.formulaInputFocus[type=password]:not(.browser-default), input.formulaInputFocus[type=email]:not(.browser-default), input.formulaInputFocus[type=url]:not(.browser-default), input.formulaInputFocus[type=time]:not(.browser-default), input.formulaInputFocus[type=date]:not(.browser-default), input.formulaInputFocus[type=datetime]:not(.browser-default), input.formulaInputFocus[type=datetime-local]:not(.browser-default), input.formulaInputFocus[type=tel]:not(.browser-default), input.formulaInputFocus[type=number]:not(.browser-default), input.formulaInputFocus[type=search]:not(.browser-default), textarea.formulaInputFocus.materialize-textarea {\n    font-size: 11px !important;\n    font-weight: bold !important;\n    box-sizing: content-box !important;\n    /* width: auto !important; */\n    min-width: 132px !important;\n    max-width: 146px !important;\n    height: 13px !important;\n    margin: 0 0 8px 0 !important;\n    margin-left: 0px !important;\n    padding: 0 !important;\n    transition: box-shadow .3s, border .3s !important;\n    border: 1px solid #000 !important;\n    /* border-bottom: 1px solid #9e9e9e !important; */\n    border-radius: 2px !important;\n    outline: none !important;\n    background-color: transparent !important;\n    box-shadow: none !important;\n    padding: 5px !important;\n}\n\n.inputsearch {\n    height: 16px !important;\n    padding: 5px !important;\n    color: #444 !important;\n    border-color: #a1a1a1 !important;\n}\n\n.inputsearchitme{\n    width: 160px !important;\n}\n.inputsearchcontainer{\n    width: 110px !important;\n}\n.inputsearchaju{\n    width: 90px !important;\n}\n\n.btn-danger{\n    background-color: rgb(95, 170, 246) !important;\n}\n\n.btn-reset{\n  background-color: rgb(217, 77, 52) !important;\n}\n\nbutton, input, optgroup, select, textarea {\n    font-family: sans-serif !important;\n    font-size: 100% !important;\n    line-height: auto !important;\n    margin-right: 5px !important;\n    /* Add other properties if needed */\n}\n\n/* Apply styles only to buttons with specific IDs */\n#replaceAllBtn, #replaceBtn, #searchAllBtn, #searchNextBtn, .luckysheet-model-close-btn{\n    height: 24px !important;\n    padding: 1px 10px 1px 10px !important;\n    vertical-align: middle !important;\n    text-transform: uppercase !important;\n    border: none !important;\n    border-radius: 2px !important;\n    -webkit-tap-highlight-color: transparent !important;\n}\n\n\n/* Style for the sticky filter column */\n.sticky-filter {\n    position: sticky !important;\n    top: 0 !important;\n    z-index: 9999999 !important;\n    background-color: #3498db !important;\n  }\n  \n  /* Style for the frozen filter column */\n  .frozen-filter {\n    position: absolute;\n  }\n  \n\n  #luckysheet-filter-menu{\n    width: 20em !important;\n  }\n\n  .btn, .btn-large, .btn-small, .btn-flat {\n    line-height: 23px !important;\n    display: inline-block !important;\n    height: 25px !important;\n    width: auto  !important;\n    vertical-align: middle !important;\n    text-transform: unset !important;\n    border: none !important;\n    border-radius: 2px !important;\n    -webkit-tap-highlight-color: transparent !important;\n    font-size: 12px !important;\n}\n\n#replaceAllBtn, #replaceBtn, #replaceTab{\n    display: none !important;\n}\n#divfkisum {\n    user-select: text;\n    cursor: pointer;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n#left-div-bottom-view {\n    flex: 1 1 20%;\n    text-align: left;\n  }\n  \n.selectFilter{\n    width: auto !important;\n    background-color: red;\n    color: #fff;\n    font-weight: bold;\n    height: 16px;\n    border-radius: 10px;\n} \n#center-div-bottom-view {\nflex: 2;\ntext-align: center;\n}\n\n#right-div-bottom-view {\nflex: 1;\ntext-align: right;\n}\n\n.mr-b-6{\n    margin-bottom: 8px;\n}\n\n#fkisum {\n    font-size: 14px !important;\n    background: #33ff00;\n    border-radius: 5px;\n    padding: 3px 5px 3px 5px;\n    font-weight: bold;\n    margin: 5px;\n    margin-right: 10px; \n}\n#fkicount {\n    font-size: 14px !important;\n    background: #ebeb34;\n    border-radius: 8px;\n    padding: 3px 5px 3px 5px;\n    font-weight: bold;\n    margin-right: 10px; \n}\n#Selisihsum {\n    font-size: 14px !important;\n    background: #a5e1a6;\n    border-radius: 8px;\n    padding: 3px 5px 3px 5px;\n    font-weight: bold;\n    margin-right: 10px; \n}\n\n.inputTextFilter {\n    width: 65% !important;\n    padding: 8px !important;\n    margin-top: 5px !important;\n    border: 1px solid #ccc !important;\n    border-radius: 4px !important;\n    box-sizing: border-box !important;\n}\n\n/*TABLE FILTER*/\n@media screen and (max-width: 900px) {\n    .responsive-table {\n      width: 100%;\n    }\n  \n    .responsive-table td,\n    .responsive-table th {\n      display: block;\n      width: 100%;\n      box-sizing: border-box;\n    }\n  \n    .responsive-table thead {\n      display: none;\n    }\n  }\n\n  .form-group {\n    margin-bottom: 10px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n  }\n  \n  .form-label {\n    margin-right: 10px;\n    font-weight: 500;\n  }\n  \n  .form-control {\n    width: 100%;\n    padding: 8px;\n    box-sizing: border-box;\n  }\n  \n  .container_report_view {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  \n  .left-side {\n    flex: 1;\n    padding: 20px;\n    background: #f9fbfd;\n    background: linear-gradient(181deg,#f9fbfd 0%, #ededed 80%);\n    background: -webkit-linear-gradient(181deg,#f9fbfd 0%, #ededed 80%);\n    background: -moz-linear-gradient(181deg,#f9fbfd 0%, #ededed 80%);\n  }\n  \n  .right-side {\n    flex: 7;\n    padding: 20px;\n    /* border-left: 1px solid #c8c8c8; */\n    height: 10000px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  }\n\n  .style-select-report{\n    width: 120px;\n  }\n\n  .style-select-report{\n    float: left;\n  }\n\n  .form-group .form-label{\n    min-width: 70px;\n    text-align: left;\n  }\n\n  .form-group .inputsearch {\n    margin-left: 0px !important;\n  }\n\n  .inputsearchdate{\n    width: 100px !important; \n  }\n\n  .inputall{\n    width: 150px !important; \n  }\n\n  #tgl{\n    float: right;\n  }\n\n  #batas{\n    height: 20px;\n  }\n\n  .group-botton{\n    float: right;\n  }\n\n  .luckyCssReport {\n    margin: 75px 5px 0px 0px;\n    padding: 0px;\n    position: absolute;\n    width: 80%;\n    height: 90%;\n    right:0;\n    top: 0px;\n    overflow-x: auto;\n  }\n\n  .luckyCssWithMenuResponsivesearch {\n    margin: 150px 0px 0px 0px;\n    padding: 0px;\n    position: absolute;\n    width: 100%;\n    height: 83.5%;\n    left: 0px;\n    top: 0px;\n    overflow-x: auto;\n  }\n\n  .luckyCssWithMenuResponsive {\n    margin: 110px 0px 0px 0px;\n    padding: 0px;\n    position: absolute;\n    width: 100%;\n    height: 85.5%;\n    left: 0px;\n    top: 0px;\n    overflow-x: auto;\n  }\n\n  .luckyCssWithMenu {\n    margin: 70px 0px 0px 0px;\n    padding: 0px;\n    position: absolute;\n    width: 100%;\n    height: 85.5%;\n    left: 0px;\n    top: 0px;\n    overflow-x: auto;\n  }\n\n  .luckyCssWithMenuResponsiveMobile {\n    margin: 110px 0px 0px 0px;\n    padding: 0px;\n    position: absolute;\n    width: 100%;\n    height: 85.5%;\n    left: 0px;\n    top: 0px;\n    overflow-x: auto;\n  }\n\n  .inputSearch{\n    height: 20px !important;\n    width: 50% !important;\n    padding: 2px !important;\n  }\n  \n  \n  @media (min-width: 2560px) {\n    .luckyCssReport {\n      margin: 75px 5px 0px 0px;\n      padding: 0px;\n      position: absolute;\n      width: 2200px;\n      height: 90%;\n      right:0;\n      top: 0px;\n      overflow-x: auto;\n    }\n    \n    .style-select-report{\n      width: 100%;\n    }\n\n    .style-select-report{\n      width: 150px;\n    }\n  }\n\n  @media (min-width: 1440px) and (max-width: 2560px){\n    .luckyCssReport {\n      margin: 75px 5px 0px 0px;\n      padding: 0px;\n      position: absolute;\n      width: 84.7%;\n      height: 91.5%;\n      right:0;\n      top: 0px;\n      overflow-x: auto;\n    }\n    \n    .style-select-report{\n      width: 100%;\n    }\n\n    .style-select-report{\n      width: 150px;\n    }\n  }\n\n  @media(min-width: 1024px)and (max-width: 1500px) {\n    .container {\n      flex-direction: column;\n    }\n    .left-side {\n        flex: 1;\n        padding: 12px;\n      }\n      \n      .right-side {\n        flex: 7;\n        padding: 12px;\n      }\n\n      .luckyCssReport {\n        margin: 75px 5px 0px 0px;\n        padding: 0px;\n        position: absolute;\n        width: 82.5%;\n        height: 90.5%;\n        right:0;\n        top: 0px;\n        overflow-x: auto;\n      }\n\n      .style-select-report{\n        width: 130px;\n      }\n\n      .inputsearchdate{\n        width: 110px !important; \n      }\n    \n      .inputall{\n        width: 130px !important; \n      }\n    \n  }\n\n\n  /* @media (min-width: 770px) and (max-width: 1024px) {\n    .container {\n      flex-direction: column;\n    }\n    .left-side {\n        flex: 1;\n        padding: 10px;\n      }\n      \n      .right-side {\n        flex: 6;\n        padding: 10px;\n      }\n\n      .luckyCssReport {\n        margin: 75px 5px 0px 0px;\n        padding: 0px;\n        position: absolute;\n        width: 780px;\n        height: 80%;\n        right:0;\n        top: 0px;\n        overflow-x: auto;\n      }\n\n      .style-select-report{\n        width: 90px;\n      }\n      .inputall{\n        width: 120px !important; \n      }\n  } */\n\n  /* @media (max-width: 769px) {\n    .container {\n      flex-direction: column;\n    }\n\n    .left-side {\n        flex: 1;\n        padding: 20px;\n      }\n      \n      .right-side {\n        flex: 4;\n        padding: 20px;\n      }\n\n      .luckyCssReport {\n        margin: 73px 0px 0px 0px;\n        padding: 0px;\n        position: absolute;\n        width: 479px;\n        height: 80%;\n        right:0;\n        top: 0px;\n        overflow-x: auto;\n      }\n\n      .style-select-report{\n        width: 100px;\n      }\n\n      .luckyCssWithMenuResponsive {\n        margin: 160px 0px 0px 0px;\n        padding: 0px;\n        position: absolute;\n        width: 100%;\n        height: 80%;\n        left: 0px;\n        top: 0px;\n        overflow-x: auto;\n      }\n\n      .luckyCssWithMenuResponsiveMobile {\n        margin: 160px 0px 0px 0px;\n        padding: 0px;\n        position: absolute;\n        width: 100%;\n        height: 80%;\n        left: 0px;\n        top: 0px;\n        overflow-x: auto;\n      }\n\n      .btn, .btn-large, .btn-small, .btn-flat {\n        line-height: 23px !important;\n        display: inline-block !important;\n        height: 25px !important;\n        width: auto  !important;\n        vertical-align: middle !important;\n        text-transform: unset !important;\n        border: none !important;\n        border-radius: 2px !important;\n        -webkit-tap-highlight-color: transparent !important;\n        font-size: 12px !important;\n      }\n  }\n\n  @media (min-width: 320px) and (max-width: 430px) {\n    .container {\n      flex-direction: column;\n    }\n\n    .left-side {\n        flex: 1;\n        padding: 20px;\n      }\n      \n      .right-side {\n        flex: 4;\n        padding: 20px;\n      }\n\n      .luckyCssReport {\n        margin: 73px 0px 0px 0px;\n        padding: 0px;\n        position: absolute;\n        width: 479px;\n        height: 80%;\n        right:0;\n        top: 0px;\n        overflow-x: auto;\n      }\n\n      .style-select-report{\n        width: 100px;\n      }\n\n      .luckyCssWithMenuResponsive {\n        margin: 180px 0px 0px 0px;\n        padding: 0px;\n        position: absolute;\n        width: 100%;\n        height: 80%;\n        left: 0px;\n        top: 0px;\n        overflow-x: auto;\n      }\n\n      .luckyCssWithMenuResponsiveMobile {\n        margin: 180px 0px 0px 0px;\n        padding: 0px;\n        position: absolute;\n        width: 100%;\n        height: 75%;\n        left: 0px;\n        top: 0px;\n        overflow-x: auto;\n      }\n\n      .btn, .btn-large, .btn-small, .btn-flat {\n        line-height: 23px !important;\n        display: inline-block !important;\n        height: 25px !important;\n        width: auto  !important;\n        vertical-align: middle !important;\n        text-transform: unset !important;\n        border: none !important;\n        border-radius: 2px !important;\n        -webkit-tap-highlight-color: transparent !important;\n        font-size: 12px !important;\n        margin-top: 5px;\n      }\n  }\n\n  @media (max-width: 320px) {\n    .container {\n      flex-direction: column;\n    }\n\n    .left-side {\n        flex: 1;\n        padding: 20px;\n      }\n      \n      .right-side {\n        flex: 4;\n        padding: 20px;\n      }\n\n      .luckyCssReport {\n        margin: 73px 0px 0px 0px;\n        padding: 0px;\n        position: absolute;\n        width: 479px;\n        height: 80%;\n        right:0;\n        top: 0px;\n        overflow-x: auto;\n      }\n\n      .style-select-report{\n        width: 100px;\n      }\n\n      .luckyCssWithMenuResponsive {\n        margin: 220px 0px 0px 0px;\n        padding: 0px;\n        position: absolute;\n        width: 100%;\n        height: 75%;\n        left: 0px;\n        top: 0px;\n        overflow-x: auto;\n      }\n\n\n      .btn, .btn-large, .btn-small, .btn-flat {\n        line-height: 23px !important;\n        display: inline-block !important;\n        height: 25px !important;\n        width: auto  !important;\n        vertical-align: middle !important;\n        text-transform: unset !important;\n        border: none !important;\n        border-radius: 2px !important;\n        -webkit-tap-highlight-color: transparent !important;\n        font-size: 12px !important;\n        margin-top: 5px;\n      }\n  } */\n\n\n.table-bordered {\n  border-collapse: collapse;\n  border: 1px solid black;\n}\n.table-bordered th, .table-bordered td {\n  border: 1px solid black;\n}\n\n\nul.tabs{\n\tmargin: 0px;\n\tpadding: 0px;\n\tlist-style: none;\n}\nul.tabs li{\n\tbackground: none;\n\tcolor: #222;\n\tdisplay: inline-block;\n\tpadding: 10px 15px;\n\tcursor: pointer;\n}\n\nul.tabs li.current{\n\tbackground: #ededed;\n\tcolor: #222;\n}\n\n.tab-content{\n\tdisplay: none;\n\tbackground: #ededed;\n\tpadding: 15px;\n}\n\n.tab-content.current{\n\tdisplay: block;\n  width: 100%;\n}\n\n.showDiv{\n  display: block;\n}\n.hideDiv {\n  display: none;\n}\n.redFont{\n  color: red;\n}\n\n.table tbody tr:nth-child(even) {\n  background-color: #e7e7e7; /* Light gray background for even rows */\n}\n\n.table tbody tr:nth-child(odd) {\n  background-color: #fafafa; /* White background for odd rows */\n}\n\ntr.total_row td {\n  font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
